import {
  AntTheme,
  AntThemeVariables,
  CustomTheme,
} from '../../../../../main-service/infrastructure/types/features/themes/theme-types';

const antVariablesMap: Record<keyof AntThemeVariables, string> = {
  colorPrimary: 'primary.brandColor',
  colorPrimaryBorder: 'primary.border',
  colorPrimaryHover: 'primary.hover',
  primaryColor: 'primary.textColor',
  colorPrimaryActive: 'primary.active',

  defaultHoverColor: 'default.hover',
  defaultHoverBorderColor: 'default.hoverBorder',
  defaultHoverBg: 'default.hoverBackground',
  defaultActiveColor: 'default.active',
  defaultActiveBorderColor: 'default.activeBorder',
  defaultColor: 'default.color',

  activeBorderColor: 'primary.borderActiveColor',

  colorBgContainerDisabled: 'default.backgroundDisabled',
  colorTextDisabled: 'default.textDisabled',

  colorInfo: 'info.brandColor',
  itemColor: 'primary.itemColor',
  itemSelectedColor: 'primary.itemSelectedColor',
  subMenuItemSelectedColor: 'primary.subItemColor',

  itemActiveColor: 'primary.brandColor',
  inkBarColor: 'primary.brandColor',
};

const componentNameMap: Record<string, string> = {
  button: 'Button',
  steps: 'Steps',
  notification: 'Notification',
  menu: 'Menu',
  input: 'Input',
  progress: 'Progress',
  tabs: 'Tabs',
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getValueByPath(obj: any, path: string): any {
  return path.split('.').reduce((acc, key) => acc?.[key], obj);
}

function generateComponentThemeMap(components: CustomTheme): AntTheme {
  const result: AntTheme = {};

  for (const [customComponentName, variantObject] of Object.entries(components)) {
    const antComponentName =
      componentNameMap[customComponentName] ?? capitalize(customComponentName);
    const tokens: Record<string, Color> = {};

    for (const [antKey, customPath] of Object.entries(antVariablesMap)) {
      const value = getValueByPath(variantObject, customPath);
      if (value) {
        tokens[antKey] = value;
      }
    }

    if (Object.keys(tokens).length > 0) {
      result[antComponentName] = tokens;
    }
  }

  return result;
}

function capitalize(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export { generateComponentThemeMap };
